export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8879.73134285.jpg";